{
  "name": "@swaggerhub-portal/frontend",
  "version": "1.20261102.2",
  "repository": {
    "type": "git",
    "url": "https://github.com/SmartBear/swaggerhub-portal-frontend.git"
  },
  "contributors": [
    "Ben Crosse",
    "Raoul Gheletus",
    "Mariia Suhan",
    "Paulina Łukasik",
    "Darek Pławecki",
    "Dmytro Dzhuriak",
    "Damian Bil",
    "Laura Kennedy",
    "Barry Coughlan"
  ],
  "private": true,
  "sideEffects": false,
  "workspaces": [
    "app",
    "packages/*"
  ],
  "type": "module",
  "scripts": {
    "postinstall": "patch-package",
    "autofix-lint": "eslint --fix app --ext js,jsx,ts,tsx",
    "build": "npm run build:component-library && npm run build:portal",
    "build:portal": "export NODE_OPTIONS=--max-old-space-size=8192 && run-s build:portal:*",
    "build:portal-local-be": "SP_API_INTERNAL_URL=http://localhost NODE_OPTIONS=--max-old-space-size=8192 run-s build:portal:*",
    "build:portal:app": "react-router build",
    "build:portal:types": "react-router typegen && tsc",
    "build:portal:server": "node esbuild.server.mjs",
    "build:component-library": "npm run build -w packages/component-library",
    "build:component-library:publish": "npm run build:publish -w packages/component-library",
    "build:component-library:watch": "npm run build:watch -w packages/component-library",
    "bugsnag-upload": "tsx bugsnag-upload.ts",
    "dev": "export NODE_OPTIONS=--max-old-space-size=8192 && npm run dev:no-build",
    "dev-local-be": "SP_API_INTERNAL_URL=http://localhost NODE_OPTIONS=--max-old-space-size=8192 npm run dev:no-build",
    "dev:no-build": "cross-env NODE_ENV=development react-router typegen && tsc --noEmit && node --no-warnings=ExperimentalWarning --env-file=.env --import tsx --import ./tracing.mjs server/server.ts",
    "docker": "docker-compose -f docker-compose.yaml up -d",
    "lint": "eslint --report-unused-disable-directives --max-warnings 0 && npm run lint:component-library",
    "lint:component-library": "npm run lint -w packages/component-library",
    "start": "cross-env NODE_ENV=production node --no-warnings=ExperimentalWarning --env-file=.env --import tsx --import ./tracing.mjs server/server.ts",
    "test": "npm run test:portal && npm run test:shared && npm run test:component-library",
    "test:portal": "cross-env TEST_MODE=portal vitest run --coverage",
    "test:portal:watch": "cross-env TEST_MODE=portal vitest watch",
    "test:shared": "cross-env TEST_MODE=shared vitest run --coverage",
    "test:shared:watch": "cross-env TEST_MODE=shared vitest watch",
    "test:component-library": "npm run test -w packages/component-library -- --coverage",
    "prepare": "husky"
  },
  "eslintIgnore": [
    "/node_modules",
    "/build",
    "/public/build"
  ],
  "dependencies": {
    "@amplitude/analytics-browser": "2.48.1",
    "@amplitude/engagement-browser": "1.0.12",
    "@amplitude/plugin-session-replay-browser": "1.36.5",
    "@asyncapi/react-component": "3.2.2",
    "@bugsnag/js": "9.1.0",
    "@bugsnag/plugin-react": "9.1.0",
    "@ckeditor/ckeditor5-react": "12.0.0",
    "@fatso83/retry-dynamic-import": "2.3.0",
    "@fontsource/inter": "5.3.0",
    "@fontsource/lato": "5.3.0",
    "@fontsource/merriweather": "5.3.0",
    "@fontsource/montserrat": "5.3.0",
    "@fontsource/open-sans": "5.3.0",
    "@fontsource/playfair-display": "5.3.0",
    "@fontsource/roboto": "5.3.0",
    "@headlessui/react": "2.2.10",
    "@hookform/resolvers": "6.0.2",
    "@launchdarkly/node-server-sdk": "9.16.0",
    "@markdoc/markdoc": "0.5.11",
    "@minoru/react-dnd-treeview": "3.5.4",
    "@opentelemetry/api": "1.10.0",
    "@opentelemetry/exporter-trace-otlp-grpc": "0.300.0",
    "@opentelemetry/instrumentation-http": "0.300.0",
    "@opentelemetry/instrumentation-undici": "0.34.0",
    "@opentelemetry/sdk-node": "0.300.0",
    "@react-router/express": "8.5.1",
    "@react-router/fs-routes": "8.5.1",
    "@react-router/node": "8.5.1",
    "@sindresorhus/slugify": "3.0.1",
    "@smartbear/safe-url-resolver": "0.10.1",
    "@smartbear/swagger-portal-component-library": "2.3.17",
    "@socket.io/postgres-adapter": "0.5.0",
    "@socket.io/redis-adapter": "8.3.0",
    "@stoplight/elements": "9.0.29",
    "@stoplight/elements-core": "9.0.29",
    "@stoplight/http-spec": "7.1.0",
    "@stoplight/mosaic": "1.53.5",
    "@tanstack/react-table": "9.3.1",
    "@tanstack/react-virtual": "3.14.25",
    "@toast-ui/react-editor": "3.2.3",
    "@types/pg": "8.23.1",
    "allotment": "1.20.6",
    "ckeditor5": "49.0.1",
    "ckeditor5-premium-features": "49.0.1",
    "clsx": "2.1.1",
    "composable-functions": "5.0.1",
    "compression": "1.8.2",
    "cross-env": "10.1.0",
    "dayjs": "1.11.23",
    "deepmerge": "4.3.1",
    "ejs": "7.0.2",
    "express": "5.3.0",
    "html-react-parser": "6.1.9",
    "htmlparser2": "12.0.0",
    "i18next": "26.5.11",
    "i18next-browser-languagedetector": "8.2.3",
    "i18next-fetch-backend": "8.0.0",
    "i18next-fs-backend": "2.6.9",
    "ioredis": "6.0.0",
    "isbot": "5.2.2",
    "jose": "6.2.15",
    "js-yaml": "5.5.0",
    "lodash": "4.18.1",
    "marked": "18.1.2",
    "morgan": "1.12.1",
    "patch-package": "^8.0.1",
    "pg": "8.23.1",
    "prism-react-editor": "3.4.0",
    "prism-react-renderer": "2.4.1",
    "prismjs": "1.30.0",
    "qs": "6.17.1",
    "raw-body": "4.0.0",
    "react": "19.3.1",
    "react-avatar": "5.0.4",
    "react-dnd": "16.0.1",
    "react-dom": "19.3.1",
    "react-helmet-async": "3.0.0",
    "react-hook-form": "7.91.0",
    "react-hot-toast": "2.6.1",
    "react-i18next": "17.1.9",
    "react-popper-tooltip": "4.4.2",
    "react-router": "8.5.1",
    "recursive-readdir": "2.2.3",
    "remix-forms": "4.0.0",
    "remix-i18next": "8.0.0",
    "remix-utils": "10.0.1",
    "sanitize-html": "2.18.1",
    "socket.io": "4.8.4",
    "socket.io-client": "4.8.4",
    "source-map-support": "0.5.21",
    "swagger-ui-react": "5.34.1",
    "tailwind-merge": "3.7.0",
    "ts-node": "10.9.2",
    "tsx": "4.23.15",
    "undici": "8.12.3",
    "usehooks-ts": "3.1.1",
    "uuid": "14.0.3",
    "vite": "8.3.5",
    "winston": "3.19.0",
    "zod": "4.6.7"
  },
  "devDependencies": {
    "@ckeditor/ckeditor5-inspector": "5.0.4",
    "@eslint/compat": "2.1.1",
    "@eslint/eslintrc": "3.3.7",
    "@eslint/js": "10.0.1",
    "@faker-js/faker": "10.6.0",
    "@react-router/dev": "8.5.1",
    "@react-router/remix-config-routes-adapter": "0.0.0-nightly-bf7ecb711-20240911",
    "@stoplight/types": "14.1.1",
    "@storybook/addon-designs": "11.1.4",
    "@storybook/addon-links": "10.6.5",
    "@storybook/addon-onboarding": "10.6.5",
    "@storybook/addon-themes": "10.6.5",
    "@storybook/icons": "2.2.0",
    "@storybook/react": "10.6.5",
    "@storybook/react-vite": "10.6.5",
    "@tailwindcss/cli": "4.3.3",
    "@tailwindcss/forms": "0.5.11",
    "@tailwindcss/postcss": "4.3.3",
    "@tailwindcss/typography": "0.5.20",
    "@tailwindcss/vite": "4.3.3",
    "@testing-library/dom": "10.4.2",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "14.6.8",
    "@types/compression": "1.8.1",
    "@types/eslint": "9.6.1",
    "@types/express": "5.0.6",
    "@types/js-yaml": "4.0.9",
    "@types/morgan": "1.9.10",
    "@types/node": "24.19.2",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@typescript-eslint/eslint-plugin": "8.72.1",
    "@typescript-eslint/parser": "8.72.1",
    "@typescript-eslint/utils": "8.72.1",
    "@typescript/native": "npm:typescript@7.0.2",
    "@vitejs/plugin-react": "6.1.2",
    "@vitest/coverage-v8": "5.0.5",
    "@vitest/eslint-plugin": "1.6.28",
    "esbuild": "0.28.2",
    "eslint": "10.13.0",
    "eslint-import-resolver-node": "0.4.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-n": "18.5.0",
    "eslint-plugin-react": "7.37.5",
    "eslint-plugin-react-refresh": "0.5.7",
    "eslint-plugin-storybook": "10.6.5",
    "globals": "17.13.0",
    "happy-dom": "21.0.4",
    "husky": "9.1.7",
    "jsdom-testing-mocks": "1.16.0",
    "msw": "3.0.3",
    "node-mocks-http": "1.18.1",
    "npm-run-all2": "9.0.4",
    "postcss": "8.5.32",
    "remix-flat-routes": "0.8.5",
    "storybook": "10.6.5",
    "supertest": "7.3.1",
    "tailwindcss": "4.3.3",
    "typescript": "npm:@typescript/typescript6@6.0.2",
    "vite-env-only": "3.0.3",
    "vite-plugin-dts": "5.1.0",
    "vitest": "5.0.5"
  },
  "packageManager": "npm@11.21.1",
  "engines": {
    "node": "24.x"
  },
  "overrides": {
    "tmp": "0.2.7",
    "js-cookie": "3.0.8",
    "dompurify": ">=3.4.6",
    "esbuild": "0.28.2",
    "brace-expansion": ">=5.0.7",
    "path-to-regexp": ">=8.4.0",
    "protobufjs": ">=8.4.1",
    "ws": ">=8.21.0",
    "jsdom": {
      "undici": "^8.12.1"
    },
    "@react-router/dev": {
      "vite": ">=7.3.2"
    },
    "vite-node": {
      "vite": "~8.3.0"
    },
    "@sentry/browser": ">=7.119.1",
    "@sentry/react": ">=7.119.1",
    "yaml": ">=2.8.3",
    "@asyncapi/parser": {
      "js-yaml": ">=4.3.2"
    },
    "@stoplight/spectral-core": {
      ".": "1.24.0",
      "minimatch": "3.1.5",
      "lodash": ">=4.18.0"
    },
    "@stoplight/spectral-functions": {
      "lodash": ">=4.18.0"
    },
    "postman-collection": {
      "lodash": ">=4.18.0",
      "@faker-js/faker": ">=10.5.0",
      "uuid": ">=11.1.1"
    },
    "@stoplight/elements": {
      "yaml": "2.9.1"
    },
    "@stoplight/elements-core": {
      "yaml": "2.9.1"
    },
    "@stoplight/http-spec": {
      "yaml": "2.9.1"
    }
  }
}
